import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter, Route} from "react-router-dom";
import { ThemeProvider } from '@material-ui/styles';
import theme from './theme'

ReactDOM.render(
    <ThemeProvider theme={theme}>
        <BrowserRouter>
            <Route component={App} />
        </BrowserRouter>
    </ThemeProvider>,
    document.querySelector('#root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
